import { Directive, HostListener, Input, Optional } from '@angular/core';
import { DialogRef } from './dialog-ref';

/**
 * Directive that closes the parent dialog on click.
 * Optionally passes a result value.
 *
 * Usage:
 * - `<button appDialogClose>X</button>` (closes with undefined)
 * - `<button [appDialogClose]="result">OK</button>` (closes with result)
 */
@Directive({
  selector: '[appDialogClose], [app-dialog-close]',
})
export class DialogCloseDirective {
  @Input('appDialogClose') dialogResult: unknown;

  constructor(@Optional() private readonly dialogRef: DialogRef | null) {}

  @HostListener('click')
  onClick(): void {
    this.dialogRef?.close(this.dialogResult);
  }
}
